import React, { useState } from 'react';
import { sideMenuItem } from './sideBarMenu';
import Arrowimage from "../../assets/Arrowicon.png";
import Arrowimageforward from "../../assets/arrow_forward.png";
import { NavLink } from 'react-router-dom';

const Sidebar = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => {
        localStorage.setItem("openvalue", !isOpen);
        setIsOpen(!isOpen);
    }

    return (
        <div className="container">
            <div style={{ width: isOpen ? "250px" : "70px", padding: isOpen ? "0px 0px 0px 26px" : "0px 0px 0px 9px" }} className="sidebar">
                <div className="top_section">
                    <h1 style={{
                        display: isOpen ? "block" : "none", color: '#535353', fontFamily: "Rubik",
                        fontWeight: "normal"
                    }} className="logo">MENU</h1>
                    <div style={{ marginLeft: isOpen ? "50px" : "0px" }} className="bars">
                        {isOpen ? (
                            <img
                                onClick={toggle}
                                src={Arrowimage}
                                alt="menu"
                            />
                        ) : <img
                            onClick={toggle}
                            src={Arrowimageforward}
                            alt="arrow"
                        />}

                    </div>
                </div>
                {
                    sideMenuItem.map((item, index) => (
                        <NavLink to={item.path} key={index} className="link" activeclassName="active">
                            <img className="icon"
                                src={item.icon}
                                alt="link"
                            />
                            <div style={{ display: isOpen ? "block" : "none" }} className="link_text">{item.name}</div>
                        </NavLink>
                    ))
                }
            </div>
            <main style={{ marginLeft: isOpen ? "23%" : "8%" }}>{children}</main>
        </div>
    );
};

export default Sidebar;
